import { GetClickableSwisslosProps } from './types'

const getClickableSwisslosProps = ({
  href,
  onClickTracking,
}: GetClickableSwisslosProps) => {
  return {
    href,
    target: '_blank',
    rel: 'nofollow noopener',
    ariaLabel: 'Swisslos',
    onClick: () => {
      onClickTracking?.()
    },
  }
}

export { getClickableSwisslosProps }
